import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import PortfolioSection from "./components/PortfolioSection";
import ServicesSection from "./components/ServicesSection";
import HowWeWorkSection from "./components/HowWeWorkSection";
import MoneyButtonSection from "./components/MoneyButtonSection";
import AboutSection from "./components/AboutSection";
import TeamSection from "./components/TeamSection";
import ContactSection from "./components/ContactSection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  return (
    <div className="min-h-screen bg-dark-900 text-white">
      <Navbar />
      <HeroSection />
      <PortfolioSection />
      <ServicesSection />
      <HowWeWorkSection />
      <MoneyButtonSection />
      <AboutSection />
      <TeamSection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}